export async function fetchAllPages<T>(
  fetchPage: (
    page: number,
    limit: number,
  ) => Promise<{ data: T[]; meta?: Record<string, unknown> }>,
  pageSize = 500,
  maxPages = 200,
): Promise<T[]> {
  if (!Number.isInteger(pageSize) || pageSize <= 0) {
    throw new Error('pageSize must be a positive integer')
  }
  if (!Number.isInteger(maxPages) || maxPages <= 0) {
    throw new Error('maxPages must be a positive integer')
  }

  const out: T[] = []
  let page = 1
  while (page <= maxPages) {
    const res = await fetchPage(page, pageSize)
    const rows = res.data ?? []
    out.push(...rows)
    const meta = res.meta ?? {}
    const totalPages =
      typeof meta.totalPages === 'number'
        ? meta.totalPages
        : typeof meta.totalItems === 'number' &&
            typeof meta.itemsPerPage === 'number' &&
            meta.itemsPerPage > 0
          ? Math.ceil(meta.totalItems / meta.itemsPerPage)
          : typeof meta.total === 'number' &&
              typeof meta.take === 'number' &&
              meta.take > 0
            ? Math.ceil(meta.total / meta.take)
            : undefined
    const currentPage =
      typeof meta.currentPage === 'number' ? meta.currentPage : page
    const hasNextPage =
      typeof meta.hasNextPage === 'boolean' ? meta.hasNextPage : undefined
    const isLastPage =
      hasNextPage === false ||
      (totalPages !== undefined && currentPage >= totalPages) ||
      (hasNextPage === undefined &&
        totalPages === undefined &&
        rows.length < pageSize)

    if (isLastPage) return out
    if (page === maxPages) {
      throw new Error(
        `Pagination exceeded the ${maxPages}-page safety bound; refusing to return a truncated result`,
      )
    }

    const nextPage = currentPage + 1
    if (nextPage <= page) {
      throw new Error('Pagination did not advance')
    }
    page = nextPage
  }
  return out
}
